import type { DMConversationMessage } from '@/components/pages/conversations/SocialInbox/types';

import { BaseMedia } from './BaseMedia';

type ImageFileInfo = {
    width: number;
    height: number;
    size: number;
    mime_type: string;
    aspect_ratio: number;
};

const DEFAULT_DIMENSION = 256;

export class ImageMedia extends BaseMedia {
    type: 'image';
    image: string;
    file_info: ImageFileInfo;

    constructor(attachment: DMConversationMessage['attachments'][0]) {
        super(attachment);
        this.type = 'image';
        this.image = attachment.url;

        const width = parseInt(attachment.width || '0', 10) || DEFAULT_DIMENSION;
        const height = parseInt(attachment.height || '0', 10) || DEFAULT_DIMENSION;

        this.file_info = {
            width,
            height,
            size: 0,
            mime_type: attachment.type || 'image/jpeg',
            aspect_ratio: height > 0 ? width / height : 1
        };
    }
}
